import Constants from "../../aframeboxlookup/Constants";
import { IPayloadWrapper } from "../types/PayloadWrapper";

const { ActionStates, AFrameControlStationType } = Constants;
/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */
const SET_AFRAME_ACTION = "automatpacken/aFrameAppMode/SET_AFRAME_ACTION";
const TOGGLE_SCAN_DISABLED = "automatpacken/aFrameAppMode/TOGGLE_SCAN_DISABLED";
const TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL =
  "automatpacken/aFrameAppMode/TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL";
const SET_AFRAME_CONTROL_STATION_TYPE =
  "automatpacken/aFrameAppMode/SET_AFRAME_CONTROL_STATION_TYPE";
const SET_AFRAME_CONTROL_STATION_VISIBLE_TYPE =
  "automatpacken/aFrameAppMode/SET_AFRAME_CONTROL_STATION_VISIBLE_TYPE";
const CLEAR_AFRAME_MODE_STATE = "automatpacken/aFrameAppMode/CLEAR_AFRAME_MODE_STATE";
const SET_AFRAME_REVIEW_MESSAGE = "automatpacken/aFrameAppMode/SET_AFRAME_REVIEW_MESSAGE";
/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */

export const setAFrameAction = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_AFRAME_ACTION,
    payload,
  };
};

export const toggleScanDisabled = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: TOGGLE_SCAN_DISABLED,
    payload,
  };
};

export const toggleverifyIPackBoxBarcodeModal = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL,
    payload,
  };
};

export const setAFrameControlStationType = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_AFRAME_CONTROL_STATION_TYPE,
    payload,
  };
};

export const setAFrameControlStationVisibleType = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_AFRAME_CONTROL_STATION_VISIBLE_TYPE,
    payload,
  };
};

export const clearAFrameModeState = () => {
  return {
    type: CLEAR_AFRAME_MODE_STATE,
  };
};

export const setAframeReviewWarning = (payload: IPayloadWrapper<string|null>) => {
  return {
    type: SET_AFRAME_REVIEW_MESSAGE,
    payload,
  };
};

const initialAFrameModeReducer: any = {
  aFrameAction: ActionStates.LOAD_BOX,
  scanDisabled: false,
  verifyIPackBoxBarcodeModalOpen: false,
  aFrameControlStationType: null,
  aFrameControlStationVisibleType: null,
  boxCancellationMessageShown: false,
  warningMessage:null
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const aFrameModeReducer = (state = initialAFrameModeReducer, action: any) => {
  switch (action.type) {
    case SET_AFRAME_ACTION:
      return { ...state, aFrameAction: action.payload.value };
    case TOGGLE_SCAN_DISABLED:
      return { ...state, scanDisabled: action.payload.value };
    case TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL:
      return { ...state, verifyIPackBoxBarcodeModalOpen: action.payload.value };
    case SET_AFRAME_CONTROL_STATION_TYPE:
      return { ...state, aFrameControlStationType: action.payload.value };
    case CLEAR_AFRAME_MODE_STATE:
      return { ...state, ...initialAFrameModeReducer };
    case SET_AFRAME_CONTROL_STATION_VISIBLE_TYPE:
      return { ...state, aFrameControlStationVisibleType: action.payload.value };
    case SET_AFRAME_REVIEW_MESSAGE:
      return { ...state, warningMessage: action.payload.value };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default aFrameModeReducer;
